import { defineMessage, defineMessages } from "react-intl";

export const recommended = defineMessage({
    id: "priceFinder.recommended",
    defaultMessage: "Recommended"
});

export const units = defineMessages({
    teamSizePrompt: {
        id: "priceFinder.teamSizePrompt",
        defaultMessage: "Team Size:"
    },
    usersUnitsLabel: {
        id: "priceFinder.usersUnitsLabel",
        defaultMessage: "users"
    },
    agentsUnitsLabel: {
        id: "priceFinder.agentsUnitsLabel",
        defaultMessage: "agents"
    }
});

export const perUserPerMonth = defineMessage({
    id: "priceFinder.perUnitPerMonth",
    defaultMessage: "per user / month"
});

export const perYear = defineMessage({
    id: "priceFinder.perYear",
    defaultMessage: "per year"
});

export const aboveUnitMaxThreshold = defineMessages({
    default: {
        id: "priceFinder.aboveUserMaxThreshold.default",
        defaultMessage: "Your user count exceeds this plan's limit"
    },
    cloudEnterprise: {
        id: "priceFinder.aboveUserMaxThreshold.cloudEnterprise",
        defaultMessage:
            "Talk to our sales team about pricing for Cloud Enterprise"
    },
    agents: {
        id: "priceFinder.aboveUserMaxThreshold.agents",
        defaultMessage: "Your agent count exceeds this plan's limit"
    },
    specificCount: {
        id: "priceFinder.aboveUserMaxThreshold.specificCount",
        defaultMessage:
            "For teams of more than {lowerLimit}, contact our sales team."
    },
    creators: {
        id: "priceFinder.aboveUserMaxThreshold.creators",
        defaultMessage: "Your creator count exceeds this plan's limit"
    }
});

export const belowUnitMinThreshold = defineMessages({
    cloudEnterprise: {
        id: "priceFinder.belowUnitMinThreshold.cloudEnterprise",
        defaultMessage:
            "Enterprise plan pricing is available when you enter {minUnitCount} or more users above"
    }
});

export const billedAnnually = defineMessage({
    id: "priceFinder.billedAnnually",
    defaultMessage: "Billed annually."
});

export const switchToAnnualToViewEnterprise = defineMessage({
    id: "priceFinder.switchToAnnualToViewEnterprise",
    defaultMessage: "Switch to Annual billing above to view Enterprise pricing."
});

export const enterpriseJpyMessage = defineMessage({
    id: "priceFinder.enterpriseJpyMessage",
    defaultMessage:
        "For pricing details see FAQ below or talk to our sales team"
});
